// components/Footer.jsx
import React from 'react';
import { Box, Typography } from '@mui/material';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'transparent',
        py: 4,
        mt: 'auto',
        textAlign: 'center',
      }}
    >
      <Typography
        variant="body2"
        sx={{
          color: 'text.secondary',
          opacity: 0.6,
          fontSize: '0.875rem',
        }}
      >
        © {currentYear} AediaX . All rights reserved.
      </Typography>
    </Box>
  );
};

export default Footer;